export default "__VITE_PUBLIC_ASSET__aa873891__"